import { useEffect, useRef, useState } from "react";

export function useCopyToClipboard(text) {
    const [copied, setCopied] = useState(false);
    const [showManual, setShowManual] = useState(false);
    const textareaRef = useRef(null);

    // Focus & select the manual textarea when shown
    useEffect(() => {
        if (showManual && textareaRef.current) {
            textareaRef.current.focus();
            textareaRef.current.select();
        }
    }, [showManual]);

    const copy = async () => {
        const value = text ?? "";

        // Secure context: modern Clipboard API
        if (window.isSecureContext && navigator.clipboard?.writeText) {
            try {
                await navigator.clipboard.writeText(value);
                setCopied(true);
                setTimeout(() => setCopied(false), 1500);
                return;
            } catch {
                // fall through to manual UI
            }
        }

        // Insecure context (http/file://) or blocked: show manual UI
        setShowManual(true);
    };

    const ManualCopyUI = showManual ? (
        <div
            style={{
                marginTop: 8,
                border: "1px solid #e5e7eb",
                borderRadius: 6,
                padding: 8,
                background: "#fffdf7",
            }}
        >
            <div style={{ fontSize: 12, marginBottom: 6, color: "#374151" }}>
                Your browser isn’t in a secure context. Press{" "}
                <b>{/Mac|iPhone|iPad|iPod/i.test(navigator.userAgent) ? "⌘" : "Ctrl"} + C</b> to copy:
            </div>
            <textarea
                ref={textareaRef}
                readOnly
                value={text ?? ""}
                style={{
                    width: "100%",
                    minHeight: 80,
                    fontFamily: "monospace",
                    fontSize: 12,
                    padding: 8,
                    background: "#f9fafb",
                    border: "1px solid #e5e7eb",
                    borderRadius: 6,
                }}
            />
        </div>
    ) : null;

    return { copied, copy, ManualCopyUI, setShowManual };
}
